import { Box, Button, Card, Typography } from '@mui/material'
import logo from 'assets/logo-light.svg'
import { useAuthenticationModel } from 'domain/authentication/authentication.model'
import { useTranslation } from 'react-i18next'

/**
 * The login page
 * @category General
 */
export function Login(): JSX.Element {
  const { t } = useTranslation()
  const { login } = useAuthenticationModel()
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Card
        sx={{
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '90%',
          maxWidth: '500px',
          border: 'none',
        }}
      >
        <Typography variant='body1' component='div' color='white'>
          <img
            alt='comstruct'
            src={logo}
            style={{ height: '70px', paddingTop: '7px' }}
          />
        </Typography>
        <Typography variant='h1' sx={{ my: 3 }}>
          {t('welcome_to_comstruct')}
        </Typography>
        <Button
          sx={{ mt: '20px', my: 2, display: 'block' }}
          onClick={login}
          variant='contained'
        >
          {t('register')}
        </Button>
        <Typography
          variant='body1'
          sx={{
            mt: '20px',
            textAlign: 'center',
            position: 'absolute',
            bottom: 5,
            left: 0,
            width: '100%',
          }}
          color={'text.secondary'}
        >
          <a
            style={{
              color: 'inherit',
              textDecoration: 'none',
            }}
            href='https://www.comstruct.com/impressum/'
          >
            {t('imprint')}
          </a>{' '}
          |{' '}
          <a
            style={{
              color: 'inherit',
              textDecoration: 'none',
            }}
            href='https://www.comstruct.com/datenschutzerklarung/'
          >
            {t('data_privacy')}
          </a>
        </Typography>
      </Card>
    </Box>
  )
}
